var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"wide":""}},[_c('base-card',{attrs:{"medium":""}},[_c('div',{staticClass:"grid"},[_c('catalog-filter-container',{staticClass:"left-col"}),_c('div',[_c('catalog-product-single-container')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }